/**
 * @generated SignedSource<<779f89456028b7e26bf91d0feb0aa62e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LibraryRow_piece$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "LibraryRow_piece";
};
export type LibraryRow_piece$key = {
  readonly " $data"?: LibraryRow_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"LibraryRow_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LibraryRow_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "7f92845b3481f39d033c5c6ad23bd518";

export default node;
